import React, { useEffect, useState } from "react";
import { Grid, Paper } from "@material-ui/core";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { PageTitle } from "../components/utils/PageTitle";
import ReactPlayer from "react-player";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardContent";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { pDataProvider } from "../utils/parameters";
import { useDataProvider } from "../api/DataProvider";
import { useCommProvider } from "../api/CommProvider";
import { Tooltip } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { pDataOrigin, pDataTypeVideo } from "../utils/parameters";

import VideocamIcon from '@mui/icons-material/Videocam';
import EmergencyRecordingIcon from '@mui/icons-material/EmergencyRecording';
import MyLocationIcon from '@mui/icons-material/MyLocation';

import { IconButton } from '@mui/material';
import { MoveYourSkeletonDialog } from "../components/moveYourSkeletonDialog/MoveYourSkeletonDialog";
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import { useTranslation } from "react-i18next";


var lodash = require("lodash");

import "../styles/devices/mob_VersusMachine.css";
import "../styles/devices/mob_Hub.css";

const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} square {...props} />)(({ theme }) => ({
  borderBottomLeftRadius: "10px",
  borderBottomRightRadius: "10px",
}));

const AccordionSummary = styled((props) => <MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem", color: "white", marginRight: "10px" }} />} {...props} />)(({ theme }) => ({
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  backgroundColor: "white",
  border: "1px solid #5ea0d4",
  borderBottomLeftRadius: "10px",
  borderBottomRightRadius: "10px",
}));

const SCREEN_INIT = 1;
const SCREEN_ACTION = 2;

const SHOW_ORIGINAL = 0
const SHOW_OVERLAY = 1
const SHOW_KEYPOINTS = 2

const TEMPLATE_DATA = {
  gloss_id: "",
  video_user: "",
  counter_repeats_used: 0,
};

export function InterfaceDonateSentence() {
  const { t } = useTranslation("global")
  
  const { comm_getPublicURLVideoData } = useDataProvider();

  const [ activeScreen, setActiveScreen] = useState(SCREEN_INIT);
  const { token_id, currentUser, json_data_glosses, json_data_meaning } = useDataProvider();
  const { comm_getDataMoveYourSkeleton, comm_sendResultsMoveYourSkeleton, comm_getVideoData } = useCommProvider();

  const [url_request_vid_original, set_url_vid_original] = useState("");
  const [url_request_vid_keypoints, set_url_vid_keypoints] = useState("");
  const [url_request_vid_overlay, set_url_vid_overlay] = useState("");

  const [user_vid_original, set_user_vid_original] = useState(null);
  const [user_vid_keypoints, set_user_vid_keypoints] = useState(null);
  const [user_vid_overlay, set_user_vid_overlay] = useState(null);

  const [ video_reference, setVideo_reference ] = useState(null)
  const [ video_user, setVideo_user ] = useState(null)

  const [video_request_play, setVideo_request_play] = useState(true);
  const [video_user_play, setVideo_user_play] = useState(false);
  
  const [isCompleted, setIsCompleted] = useState(false);
  const [accordionExpanded, setAccordionExpanded] = useState(false);

  const [ show_video, setShow_video ] = useState(SHOW_ORIGINAL); // 0: Overlay, 1: Keypoints

  const [ openDialog, setOpenDialog ] = useState(false);
  const [ request_gloss_id, setRequest_gloss_id ] = useState('')
  const [ response_video_user, setResponse_video_user ] = useState('')
  const [ counter_repeats_used, setCounter_repeats_used ] = useState(0)

  const [server_report_activity, setServer_report_activity] = useState({});    //  ACTUAL REPORT & PERSONAL MARKS & RANKING INFO
  // const [firstIteration, setFirstIteration] = useState(true);                   //  ACTUAL REPORT & PERSONAL MARKS & RANKING INFO

  const [ score_Kps, setScore_Kps ] = useState(0)
  
  

  // REQUEST DATA.
  async function obtainData() {

    // Coger el primero actualente no contemplamos organizarlo en packs (como Usuario contra máquina) sino de uno en uno.);
    setRequest_gloss_id((await comm_getDataMoveYourSkeleton(token_id, currentUser))[0]["gloss_id"]);
    setCounter_repeats_used(0);
    setShow_video(SHOW_ORIGINAL)

  }

  // useEffect(() => {
  //   console.log("GLOSS_ID", request_gloss_id);
  //   console.log("response_video_user", response_video_user);
  //   console.log("counter_repeats_used", counter_repeats_used);
  // }, [request_gloss_id, counter_repeats_used, response_video_user]);


  async function loadVideos() {
    // console.log ('LOAD VIDEOS')

    // console.log("🚀 ~ file: MoveYourSkeleton.js:118 ~ loadVideos ~ user_vid_overlay:", user_vid_overlay)
    // console.log("🚀 ~ file: MoveYourSkeleton.js:118 ~ loadVideos ~ url_request_vid_overlay:", url_request_vid_overlay)
    // console.log("🚀 ~ file: MoveYourSkeleton.js:118 ~ loadVideos ~ user_vid_keypoints:", user_vid_keypoints)
    // console.log("🚀 ~ file: MoveYourSkeleton.js:118 ~ loadVideos ~ url_request_vid_keypoints:", url_request_vid_keypoints)

    if (show_video === SHOW_ORIGINAL) {
      setVideo_reference(url_request_vid_original);      
      setVideo_user(user_vid_original);
    } 

    if (show_video === SHOW_OVERLAY) {
      setVideo_reference(url_request_vid_overlay);      
      setVideo_user(user_vid_overlay);
    } 
      
    if (show_video === SHOW_KEYPOINTS) {
      setVideo_reference(url_request_vid_keypoints);    
      setVideo_user(user_vid_keypoints);
    }
  }

  // LOADED DATA - LOAD VÍDEOS
  useEffect(() => {
    async function getVideoFromServerUserVideos(video_user) {
      // console.log('GetVideoFromServerUserVideos')
      set_user_vid_original(await comm_getVideoData(token_id, currentUser, pDataOrigin.moveYourSkeleton_LABEL, video_user, pDataTypeVideo.video_RGB));
      set_user_vid_keypoints(await comm_getVideoData(token_id, currentUser, pDataOrigin.moveYourSkeleton_LABEL, video_user, pDataTypeVideo.video_KEYPOINTS));
      set_user_vid_overlay(await comm_getVideoData(token_id, currentUser, pDataOrigin.moveYourSkeleton_LABEL, video_user, pDataTypeVideo.video_OVERLAY));
    }
    if (request_gloss_id !== "") {
      set_url_vid_original(comm_getPublicURLVideoData(pDataProvider.dir_vid_sign, request_gloss_id));
      set_url_vid_keypoints(comm_getPublicURLVideoData(pDataProvider.dir_vid_versusKeypoints, request_gloss_id));
      set_url_vid_overlay(comm_getPublicURLVideoData(pDataProvider.dir_vid_versusOverlay, request_gloss_id));

      if (response_video_user !== "") {
        getVideoFromServerUserVideos(response_video_user);
      }else{
        console.log('Skip getVideoFromServerUserVideos')
      }
    }else {

      set_url_vid_original(null)
      set_url_vid_keypoints(null)
      set_url_vid_overlay(null)

      set_user_vid_original(null)
      set_user_vid_keypoints(null)
      set_user_vid_overlay(null)
    }
  }, [request_gloss_id, response_video_user]);

  function startVideoPlay() {
    // console.log("startVideoPlay");
    setVideo_request_play(true);
    if (response_video_user !== "") {
      setVideo_user_play(true);
    }
  }

  useEffect(() => {
    loadVideos();
    startVideoPlay()
  },[show_video, url_request_vid_keypoints, url_request_vid_overlay, user_vid_keypoints, user_vid_overlay]);


  // RECORDED VIDEO - ENABLING COMPLETED STATE
  useEffect(() => {
    if (response_video_user !== '') {
      setIsCompleted(true);
      btn_Send_Server();
    } else {
      setIsCompleted(false);
    }
  }, [response_video_user]);

  
  const clickBtnRepeat = (event) => {
    setShow_video(SHOW_ORIGINAL)
    startVideoPlay()
  };

  const endVideoRequest = (event) => {

    if (show_video === SHOW_KEYPOINTS) {
      setVideo_request_play(false);
    } else{
      handleSwitchTypeData()
    }
    
  };

  const endVideoUser = (event) => {
    setVideo_user_play(false);
  };


  // CHANGE OF STATES : INIT & ACTION
  const initStateAction = () => {
    setRequest_gloss_id("");
    setResponse_video_user("");
    setCounter_repeats_used(0);

    setActiveScreen(SCREEN_ACTION);
    obtainData();
  };

  const returnMenuMoveYourSkeleton = () => {
    // console.log("returnMenuMoveYourSkeleton");
    setActiveScreen(SCREEN_INIT);
    // setFirstIteration(false);

    setRequest_gloss_id("");
    setResponse_video_user("");
    setCounter_repeats_used(0);
  };

  const returnRecorderMoveYourSkeleton = () => {
    setShow_video(SHOW_ORIGINAL)
  }
  
  const returnNextMoveYourSkeleton = () => {
    setShow_video(SHOW_ORIGINAL)
    initStateAction()
  };
  
  async function btn_Send_Server() {

    const data = {
      'gloss_id': request_gloss_id,
      'video_sign_id': response_video_user,
      'counter_repeats_used': counter_repeats_used,
      'score_kps': score_Kps,
    }

    const response = {

    }

    setServer_report_activity(await comm_sendResultsMoveYourSkeleton(token_id, currentUser, data));
    setOpenDialog(true)
  }


  // useEffect(() => {
  //   console.log("🚀 ~ file: MoveYourSkeleton.js:306 ~ MoveYourSkeleton ~ server_report_activity:", server_report_activity)
  // }, [server_report_activity]);


  async function btn_Send_Server_Only_Ranking() {
    setServer_report_activity(await comm_sendResultsMoveYourSkeleton(token_id, currentUser, {}));
    setOpenDialog(true);

  }

  const handleAccordionChange = () => {
    setAccordionExpanded(!accordionExpanded);
  };

  useEffect(() => {
    if (video_request_play) {
      setCounter_repeats_used(counter_repeats_used + 1);
    }
  }, [video_request_play, show_video]);


  const history = useHistory();

  const btn_Open_Report = () => {
    history.push({
      src: "/moveYourSkeleton"
    });
  };

  return (
    <HomeWrapper>
      <MoveYourSkeletonDialog openDialog={openDialog} setOpenDialog={setOpenDialog} server_report_activity={server_report_activity} user_vid_original={user_vid_original} user_vid_keypoints={user_vid_keypoints} user_vid_overlay={user_vid_overlay} returnMenuMoveYourSkeleton={returnMenuMoveYourSkeleton} returnRecorderMoveYourSkeleton={returnRecorderMoveYourSkeleton} returnNextMoveYourSkeleton={returnNextMoveYourSkeleton}/>
     <PageTitle title= "DONA FRASES" />

        <div className="sig_VersusMachine_Start_Screen" style={{ display: "flex", flexWrap: "wrap" }}>
          <Card className="sig_VersusMachine_CardContainer">
            <div className="sig_VersusMachine_CardActionArea">

              <Paper className="sig_VersusMachine_PaperContent">
                <div className="sig_Hub_InfoTitle sig_VersusMachine_Start_Title"> {t("sMoveYourSkeleton.btnStartQuestion")} </div>


                <Paper style={{padding: '5px', maxWidth: '85%', boxShadow: 'none', margin: '8px auto'}}>
                                    <div className='sig_SignModal_PaperInfo' style={{backgroundColor: '#89cefb17', padding: '10px', borderRadius: '4px', minHeight: '60px', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '2px solid #5ea0d4'}}>
                                        <div> "TEXTO EXPLICANDO ALGO...." </div>
                                    </div> 
                                </Paper>

                {/* <div className="sig_Hub_InfoTitle sig_VersusMachine_Start_Title"> {firstIteration ? '¿ Comenzamos ?':'¿ Continuamos ?'}</div> */}
                <Button className="sig_Hub_ButtonBig sig_Hub_Card_ButtonModal sig_VersusMachine_Fix" onClick={initStateAction}>
                  
                  {" "}
                  {"REPITE FRASE"}
                  {" "}
                </Button>

                <Button className="sig_Hub_ButtonBig sig_Hub_Card_ButtonModal sig_VersusMachine_Fix" onClick={initStateAction}>
                  
                  {" "}
                  {"RESPONDE - RESPUESTA LIBRE"}
                  {" "}
                </Button>

                <hr></hr>


                <Button className="sig_Hub_ButtonBig sig_Hub_Card_ButtonModal sig_VersusMachine_Fix" onClick={btn_Send_Server_Only_Ranking}>
                  {" "}
                  <EmojiEventsIcon className="sig_VersusMachine_Start_Icon" fontSize="large" /> {t("sVersusMachine.btnShowClasification").toUpperCase()}{" "}
                </Button>
              </Paper>
            </div>
          </Card>
        </div>
    </HomeWrapper>
  );
}
